import { render, staticRenderFns } from "./ObtainCostCalc.vue?vue&type=template&id=3051eeba&scoped=true"
import script from "./ObtainCostCalc.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObtainCostCalc.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051eeba",
  null
  
)

export default component.exports